import { render, staticRenderFns } from "./MaintainCreate.vue?vue&type=template&id=07c0b6ba&"
import script from "./MaintainCreate.vue?vue&type=script&lang=js&"
export * from "./MaintainCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports